import { Button } from "~components/ui";
import { getLinkProps } from "~lib/storyblok";
import { cn } from "~utils";
import type { CtaItemProps } from "./types";

function CtaItem({ blok, className, ...context }: Readonly<CtaItemProps>) {
  // BUTTON WIDTH
  const width = {
    full: "w-full",
    content: "w-auto max-w-max",
  }[blok.width ?? "content"];

  return blok.label && blok.link ? (
    <Button
      className={cn("whitespace-nowrap", width, className)}
      {...getLinkProps(blok.link, context)}
      variant={blok.variant}
      arrow={blok.arrow}
    >
      {blok.label}
    </Button>
  ) : null;
}

export { CtaItem };
